/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ mode: NonNullable<unknown> }} Case_Payment_Mode_LabelInputs */

const en_case_payment_mode_label = /** @type {(inputs: Case_Payment_Mode_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.mode === "upfront") return /** @type {LocalizedString} */ (`Upfront`);
	if (i?.mode === "interest_free") return /** @type {LocalizedString} */ (`Interest-free installments`);
	if (i?.mode === "interest_bearing") return /** @type {LocalizedString} */ (`Interest-bearing installments`);
	return /** @type {LocalizedString} */ (`${i?.mode}`)
	
};

const pt_br2_case_payment_mode_label = /** @type {(inputs: Case_Payment_Mode_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.mode === "upfront") return /** @type {LocalizedString} */ (`À vista`);
	if (i?.mode === "interest_free") return /** @type {LocalizedString} */ (`Parcelamento sem juros`);
	if (i?.mode === "interest_bearing") return /** @type {LocalizedString} */ (`Parcelamento com juros`);
	return /** @type {LocalizedString} */ (`${i?.mode}`)
	
};

/**
* | mode | output |
* | --- | --- |
* | "upfront" | "Upfront" |
* | "interest_free" | "Interest-free installments" |
* | "interest_bearing" | "Interest-bearing installments" |
* | * | "{mode}" |
*
* @param {Case_Payment_Mode_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_mode_label = /** @type {((inputs: Case_Payment_Mode_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Mode_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_mode_label(inputs)
	return pt_br2_case_payment_mode_label(inputs)
});